import { gql } from "@apollo/client";

export enum ProductOperation {
  UnauthenticatedSearch = "UnauthenticatedSearchProducts",
  AuthenticatedSearch = "SearchProducts",
}

export const PRODUCT_SEARCH_DEFAULT_FACETS = gql`
  query getProductSearchDefaultFacets {
    ProductSearchDefaultFacets {
      facets
      totalProducts
    }
  }
`;

export const UNAUTHENTICATED_SEARCH_PRODUCTS = gql`
  query UnauthenticatedSearchProducts(
    $titleInclude: [String!]
    $titleExclude: [String!]
    $stacklineSkus: [String!]
    $retailerSkus: [String!]
    $stacklineSkusExclude: [String!]
    $campaignTypes: [String!]
    $retailPrice: [RangeFilter!]
    $reviewsRating: RangeFilter
    $reviewsCount: RangeFilter
    $brandIds: [Float!]
    $departmentIds: [Float!]
    $categoryIds: [Float!]
    $subCategoryIds: [Float!]
    $retailerIds: [Float!]
    $isBrandClubReady: Boolean
    $totalRewardAmount: RangeFilter
    $page: PageFilter!
    $sort: [SortFilter!]
    $facetFieldNames: [String!]
    $computeFacets: Boolean!
    $applySpellingCheck: Boolean
    $treatment: TreatmentFilter
  ) {
    ${ProductOperation.UnauthenticatedSearch}(
      titleInclude: $titleInclude
      titleExclude: $titleExclude
      stacklineSkus: $stacklineSkus
      retailerSkus: $retailerSkus
      stacklineSkusExclude: $stacklineSkusExclude
      campaignTypes: $campaignTypes
      retailPrice: $retailPrice
      reviewsRating: $reviewsRating
      totalRewardAmount: $totalRewardAmount
      reviewsCount: $reviewsCount
      brandIds: $brandIds
      categoryIds: $categoryIds
      departmentIds: $departmentIds
      subCategoryIds: $subCategoryIds
      retailerIds: $retailerIds
      isBrandClubReady: $isBrandClubReady
      page: $page
      sort: $sort
      facetFieldNames: $facetFieldNames
      computeFacets: $computeFacets
      applySpellingCheck: $applySpellingCheck
      treatment: $treatment
    ) {
      products {
        affiliateRewardAmount
        brandId
        hasActiveInstantReward
        imageUrls
        retailerId
        retailerDisplayName
        retailerLogo
        retailerShortLogo
        retailerSku
        retailPrice
        checkoutEligibility
        stacklineSku
        title
        totalRewardAmount
        isAvailable
        hasFirstPartyOffer
        offers
        pixels
        scores {
          maxPurchaseRewardPercent
          maxPurchaseRewardAmount
          maxAffiliateRewardPercent
          maxAffiliateRewardAmount
          totalReviewRewardFeesAmount
        }
        matchedProducts {
          retailPrice
          retailerId
          retailerDisplayName
          retailerLogo
          retailerShortLogo
          retailerProductPageUrl
          totalRewardAmount
          stacklineSku
          retailerSku
          checkoutEligibility
          isAvailable
          hasFirstPartyOffer
          offers
        }
        campaignRewards {
          campaignStatus
          campaignType
          rewardAmount
          rewardAmountType
          rewardUnlockStrategy
        }
      }
      totalProducts
      facets
      suggestedTerm
    }
  }
`;

export const UNAUTHENTICATED_SEARCH_PRODUCTS_CHECKOUT = gql`query searchProductsWithFullDetailsUnauthenticated(
    $titleInclude: [String!]
    $titleExclude: [String!]
    $stacklineSkus: [String!]
    $stacklineSkusExclude: [String!]
    $retailerSkus: [String!]
    $campaignTypes: [String!]
    $retailPrice: [RangeFilter!]
    $reviewsRating: RangeFilter
    $reviewsCount: RangeFilter
    $brandIds: [Float!]
    $departmentIds: [Float!]
    $categoryIds: [Float!]
    $subCategoryIds: [Float!]
    $retailerIds: [Float!]
    $isBrandClubReady: Boolean
    $totalRewardAmount: RangeFilter
    $page: PageFilter!
    $sort: [SortFilter!]
    $facetFieldNames: [String!]
    $computeFacets: Boolean!
    $applySpellingCheck: Boolean
  ) {
    ${ProductOperation.UnauthenticatedSearch}(
      titleInclude: $titleInclude
      titleExclude: $titleExclude
      stacklineSkus: $stacklineSkus
      stacklineSkusExclude: $stacklineSkusExclude
      retailerSkus: $retailerSkus
      campaignTypes: $campaignTypes
      retailPrice: $retailPrice
      reviewsRating: $reviewsRating
      totalRewardAmount: $totalRewardAmount
      reviewsCount: $reviewsCount
      brandIds: $brandIds
      categoryIds: $categoryIds
      departmentIds: $departmentIds
      subCategoryIds: $subCategoryIds
      retailerIds: $retailerIds
      isBrandClubReady: $isBrandClubReady
      page: $page
      sort: $sort
      facetFieldNames: $facetFieldNames
      computeFacets: $computeFacets
      applySpellingCheck: $applySpellingCheck
    ) {
      products {
        checkoutEligibility
        stacklineSku
        title
        brandName
        brandId
        categoryId
        subCategoryId
        subCategoryName
        categoryName
        retailerId
        retailerDisplayName
        retailerLogo
        retailerShortLogo
        retailerSku
        retailPrice
        reviewsRating
        groupId
        groupName
        reviewsCount
        searchScore
        pixels
        matchedProducts {
          retailPrice
          retailerId
          retailerDisplayName
          retailerLogo
          retailerShortLogo
          retailerProductPageUrl
          totalRewardAmount
          stacklineSku
          retailerSku
          checkoutEligibility
          isAvailable
          hasFirstPartyOffer
          offers
        }
        totalRewardAmount
        isAvailable
        hasFirstPartyOffer
        offers
        scores {
          maxPurchaseRewardPercent
          maxPurchaseRewardAmount
          maxAffiliateRewardPercent
          maxAffiliateRewardAmount
          totalReviewRewardFeesAmount
        }
        hasActiveInstantReward
        featureBullets
        productPromotions {
          promoType
          isActive
          listPrice
          promoPrice
        }
        imageUrls
        campaignRewards {
          campaignId
          campaignType
          rewardAmount
          rewardAmountType
          campaignStatus
        }
        rollupParentSku
        retailerProductPageUrl
        products {
          retailerSku
          retailPrice
        }
        activeProductPromotion {
          promoType
          isActive
          listPrice
          promoPrice
        }
        childProductMinRetailPrice
        childProductMaxRetailPrice
      }
      facets
      suggestedTerm
    }
  }`;
